export default "__VITE_ASSET__8dcf9109__"